export const sortAlphabetically = (list) => list.sort((a, b) => a.label ? (a.label < b.label ? -1 : 1) : (a.title < b.title ? -1 : 1));
